<template>
  <div>
    <div :class="['top-tasks', isOpenTaskDrop ? 'active' : '']"
      @click="tasks.length != 0 ? isOpenTaskDrop = !isOpenTaskDrop : ''">
      <div class="top-tasks-no">{{  tasks.length  }}</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23">
        <g>
          <g>
            <path fill="#2b2b41"
              d="M20 3.298v18.856c0 .466-.39.846-.866.846H.866A.858.858 0 0 1 0 22.154V3.298c0-.465.39-.846.866-.846h2.189c.476 0 .866.38.866.846 0 .465-.39.845-.866.845H1.732V21.31h16.54V4.143h-4.647a.858.858 0 0 1-.866-.845V1.69H7.25V4.45h4.484c.477 0 .866.38.866.845 0 .465-.39.846-.866.846h-5.35a.859.859 0 0 1-.866-.846V.846c0-.466.39-.846.866-.846h7.236c.477 0 .866.38.866.846v1.606h4.648c.476 0 .866.38.866.846zm-6.014 8.094l-4.652 4.505a.87.87 0 0 1-.611.244.878.878 0 0 1-.616-.249L6.019 13.84a.832.832 0 0 1 .004-1.197.882.882 0 0 1 1.227.004l1.477 1.452 4.037-3.909a.881.881 0 0 1 1.227.005.832.832 0 0 1-.005 1.198z" />
          </g>
        </g>
      </svg>
    </div>
    <div class="top-tasks-menu">
      <div class="task-element-wrapper" v-for="(single_task, key) in tasks" :key="key" @click="openPopup(single_task)">
        <div :class="'vrsta-eventa event-' + single_task.event_type.class_colour">
          {{  single_task.event_type.name  }}
        </div>
        <div class="task-name">
          {{  single_task.title  }}
        </div>
      </div>
      <!-- <div class="task-divider"></div> -->
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import CalendarModal from "@/components/calendarComponents/CalendarModal.vue";
import NotificationComponent from "@/components/generalComponents/NotificationComponent.vue";
import TasksDropdown from "@/components/generalComponents/TasksDropdown.vue";

export default {
  components: { CalendarModal, NotificationComponent, TasksDropdown },
  props: {
    sioVar: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    openPopup(event) {
      setTimeout(() => {
        this.$store.state.event_details.popup_open = true;
        this.$store.state.event_details.chosen_event = event;
      }, 100);

    },
  },
  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        this.sioVar.socket.on("message tasks", (data) => {
          let old_length = this.tasks.length;
          this.tasks = []
          this.tasks = JSON.parse(data);
          if (this.hasFirstLoaded) {
            if (old_length > this.tasks.length) {
              console.log("A task has been solved.")
              gsap.to(".top-tasks-no", 1, { width: "5rem", height: "5rem", backgroundColor: "#0acab1" })
              gsap.to(".top-tasks-no", 1, { delay: 3, width: "2rem", height: "2rem" })
              gsap.to(".top-tasks-no", 0.4, { delay: 4, backgroundColor: "#fd4087" })
            } else if (old_length < this.tasks.length) {
              console.log("A task has been addded.")
              gsap.to(".top-tasks-no", 1, { width: "5rem", height: "5rem" })
              gsap.to(".top-tasks-no", 1, { delay: 3, width: "2rem", height: "2rem" })

            }
          }else{
            this.hasFirstLoaded = true;
          }


        });
      }
    },
    isOpenTaskDrop: function () {
      if (!this.isOpenTaskDrop) {
        if (!this.$parent.isOpenDropDown) {
          gsap.to(".router-wrapper", 0.5, {
            filter: "none",
            pointerEvents: "auto",
            opacity: 1,
          });
        }
        let tl = gsap.timeline();
        tl.fromTo(".top-tasks-menu", 0.3, { y: 0 }, { y: -20, opacity: 0 });

        tl.to(".top-tasks-menu", 0, { display: "none" });
      } else {
        gsap.to(".router-wrapper", 0.5, {
          filter: "blur(5px)",
          pointerEvents: "none",
          opacity: 0.5,
        });
        let tl = gsap.timeline();
        tl.to(".top-tasks-menu", 0, { display: "block" });
        tl.fromTo(".top-tasks-menu", 0.3, { y: -20 }, { y: 0, opacity: 1 });
      }
    },
  },
  data() {
    return {
      isOpenTaskDrop: false,
      tasks: [],
      hasFirstLoaded: false
    };
  },
  async created() { },
  mounted() { },
};
</script>

